module.exports = __webpack_public_path__ + "img/IMG-20200310-WA0014.529ce9ac.jpg";